import React from "react";
import Image from "next/image";
import type { StaticImageData } from "next/image";

type IndustryProcessCardProps = {
  title: string;
  description: string;
  mode?: "light" | "dark";
  icon?: string | StaticImageData;
  cta?: boolean;
  isActive?: boolean;
};

const IndustryProcessCard: React.FC<IndustryProcessCardProps> = ({
  title,
  description,
  mode = "dark",
  icon,
  isActive = false,
}) => {
  return (
    <div
      className={`col-span-4 relative flex flex-col items-start 
      /* Dot styling using pseudo-element */
      xl:after:content-[''] xl:after:absolute xl:after:top-0 xl:after:-translate-y-1/2 
      xl:after:w-[var(--space-30-40)] xl:after:h-[var(--space-30-40)] xl:after:z-[999] 
      xl:after:rounded-full xl:after:left-0 xl:after:transition-all xl:after:duration-500
      
      /* Toggle visibility based on isActive */
      ${isActive ? "xl:after:scale-100 xl:after:opacity-100" : "xl:after:scale-0 xl:after:opacity-0"}
      
      /* Color logic for the dot */
      ${mode === "light" ? "xl:after:bg-[#225bd4]" : "xl:after:bg-white"} 
      
      bg-transparent py-[var(--space-32-50)] 
      ${mode === "light" ? "text-[#00040B]" : "text-white"} 
      transition-opacity duration-300 w-full`}
    >
      {icon && (
        <div className="mb-[var(--space-15-20)] w-[50px] h-[50px] shrink-0">
          <Image
            src={icon}
            alt={title}
            width={60}
            height={60}
            className="w-full h-full object-contain"
          />
        </div>
      )}

      <h3 className="clash-font pb-[var(--space-8-10)] leading-[120%] text-[length:var(--section-subtitle)] font-[500]">
        {title}
      </h3>

      <p
        className={`text-[length:var(--industry-para)] leading-[1.5] 
      ${mode === "light" ? "opacity-60" : "opacity-80"} 
      line-clamp-5 overflow-hidden min-h-[6em]`}
      >
        {description}
      </p>
    </div>
  );
};

export default IndustryProcessCard;
